import {METHODS} from './constants';
import {ENDPOINTS} from './endpoints';

export const getBenefitsByOrgId = async (id: number | string) => {
  const response = await fetch(ENDPOINTS.benefitsById(id), {
    method: METHODS.get,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response;
};
